rdefine('app/formular/collections/TabsCollection',['backbone','app/formular/models/TabModel'],function(Backbone,model){
    return Backbone.Ribs.Collection.extend({
        model:model,
        initialize:function(options,els) {
            this.on("setactive",_.bind(this.setActive,this));
        },
        setActive:function(model) {
            this.each(function(item){
                item.set("active",false);
            });
            model.set("active",true);
        }
    });
});